function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { useSdkContext } from "~/components/contexts";
import { theme, useResponsive } from "~/lib/media";
import { useSitemap } from "./hooks";
import { Anchor, Container, Item, List, ListContainer, SecondaryList, SectionLabel } from "./styles";
export const Sitemap = ({
  ...props
}) => {
  const {
    handleRoutePush,
    handleTrackGA,
    handleTrackGA4
  } = useSdkContext();
  const {
    desktopSitemap,
    mobileSitemap
  } = useSitemap();
  const isMobile = useResponsive(theme.breakpoints.only("mobile"), false);
  const renderAnchor = link => /*#__PURE__*/React.createElement(Anchor, {
    href: link.url.alias,
    onClick: event => {
      event.preventDefault();
      handleTrackGA({
        action: "Footer/Click",
        category: "Footer",
        label: `Footer/${link.label}`
      });
      void handleRoutePush(link.url.alias, {
        applicationId: link.url.applicationId,
        entityId: link.url.entityId,
        entityUuid: link.url.entityUuid,
        isExternal: link.isExternal,
        type: link.url.type
      });
      handleTrackGA4({
        action: "click",
        category: "footer",
        customized_parameters: {
          destination_url: link.isExternal ? link.url.alias : `${window.location.origin}${link.url.alias}`,
          link_name: link.label
        },
        subcategory: ""
      });
    },
    "data-qa": "render-anchor"
  }, link.label);
  const renderDesktopSitemap = () => desktopSitemap.sections.map(section => /*#__PURE__*/React.createElement(ListContainer, {
    key: section.label
  }, /*#__PURE__*/React.createElement(SectionLabel, null, section.label), /*#__PURE__*/React.createElement(List, null, section.links.map((link, index) => /*#__PURE__*/React.createElement(Item, {
    key: index
  }, renderAnchor(link))))));
  const renderMobileSitemap = () => {
    var _mobileSitemap$linksS;
    return /*#__PURE__*/React.createElement(ListContainer, {
      "data-qa": "render-mobile-sitemap"
    }, /*#__PURE__*/React.createElement(List, null, mobileSitemap.links.map((link, index) => /*#__PURE__*/React.createElement(Item, {
      key: index
    }, renderAnchor(link)))), /*#__PURE__*/React.createElement(SecondaryList, null, (_mobileSitemap$linksS = mobileSitemap.linksSecondary) === null || _mobileSitemap$linksS === void 0 ? void 0 : _mobileSitemap$linksS.map((link, index) => /*#__PURE__*/React.createElement(Item, {
      key: index
    }, renderAnchor(link)))));
  };
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-qa": "sitemap"
  }), isMobile ? renderMobileSitemap() : renderDesktopSitemap());
};
Sitemap.displayName = "Sitemap";